'use strict';

var index = require('../../../../../index-B_8xeRkv.js');

"use strict";
const pluginVersion = "12.4.2";
const defaultOptions = {
  barRadius: 0,
  barWidth: 0.97,
  fullHighlight: false,
  groupWidth: 0.7,
  orientation: index.VizOrientation.Auto,
  showValue: index.VisibilityMode.Auto,
  stacking: index.StackingMode.None,
  xTickLabelRotation: 0,
  xTickLabelSpacing: 0
};
const defaultFieldConfig = {
  fillOpacity: 80,
  gradientMode: index.GraphGradientMode.None,
  lineWidth: 1
};

exports.defaultFieldConfig = defaultFieldConfig;
exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
